import { useParams, Navigate } from 'react-router-dom';

const RedirectToCourseEnroll = () => {
  const { id } = useParams();
  return <Navigate to={`/courses/${id}/enroll`} replace />;
};

export default RedirectToCourseEnroll;